<template>
  <div>
    <b-overlay :show="busy" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.saving") }}...
          </strong>
        </div>
        <div v-else-if="isLoading" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.loading") }}...
          </strong>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        ></div>
      </template>
    </b-overlay>

    <b-card :title="locals('msg.req')">
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(0, 207, 232, 0.15)'"
              class="custom-add"
              :to="{ name: 'request-form' }"
              pill
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{ $t("button.new") }}</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col cols="12" class="mb-2">
          <b-row>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.estimate_delivery_date')"
                label-for="i-date"
                class="title-freight"
              >
                <flat-pickr
                  class="form-control"
                  :config="{ mode: 'range', dateFormat: 'd/m/Y' }"
                  v-model="dataFilter.datDate"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-job-no"
                label="Job No."
                class="title-freight"
              >
                <b-form-input
                  id="i-job-no"
                  v-model="dataFilter.strInqJobNo"
                  placeholder="RQMxxxxxxxxx"
                  maxlength="20"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.company_name')"
                label-for="i-company"
                class="title-freight"
              >
                <v-select
                  id="i-company"
                  v-model="dataFilter.intCustomerId"
                  :placeholder="locals('select.placeholder')"
                  label="strDsName"
                  :options="custOption"
                  :reduce="(val) => val.intDsId"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.status')"
                label-for="i-status"
                class="title-freight"
              >
                <v-select
                  id="i-status"
                  :clearable="true"
                  v-model="dataFilter.intStatusId"
                  :placeholder="locals('select.placeholder')"
                  input-id="i-status"
                  label="title"
                  :options="status"
                  :reduce="(val) => val.Id"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group
                label-for="i-origin"
                class="title-freight"
                :label="locals('inquiry.origin_port')"
              >
                <b-form-input
                  id="i-origin"
                  v-model="dataFilter.strOriginalPort"
                  maxlength="100"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-dest"
                class="title-freight"
                :label="locals('inquiry.destination_port')"
              >
                <b-form-input
                  id="i-dest"
                  v-model="dataFilter.strDestPort"
                  maxlength="100"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-remark"
                :label="locals('inquiry.doc_detail')"
                class="title-freight"
              >
                <b-form-input
                  id="i-remark"
                  v-model="dataFilter.strRemark"
                  maxlength="100"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-request-type"
                class="title-freight"
                :label="locals('inquiry.type')"
              >
                <v-select
                  id="i-request-type"
                  input-id="i-request-type"
                  :clearable="true"
                  v-model="dataFilter.strJobType"
                  label="title"
                  :options="job_type"
                >
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="pt-2">
              <b-form-checkbox
                v-model="dataFilter.select_flag"
                class="title-freight"
              >
                {{ $t("report.showown") }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1 custom-search"
            pill
            @click="onSearch"
          >
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.search") }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            pill
            @click="onClear"
          >
            <feather-icon icon="RefreshCwIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.clear") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card :title="locals('msg.detail')">
      <b-row>
        <b-col md="12" style="text-align: right">
          <b-button variant="outline-info" pill @click="onExport()">
            <feather-icon icon="PrinterIcon" class="mr-50" />
            <span class="align-right">Export</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col md="12">
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: false,
            }"
            :pagination-options="{
              enabled: true,
              perPage: pageLength,
            }"
            styleClass="vgt-table condensed"
          >
            <!-- Slot: Table Column -->
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.label === 'Action'" class="text-nowrap">
                {{ $t("inquiry.action") }}
              </span>
              <span
                v-else-if="props.column.label === 'สถานะ'"
                class="text-nowrap"
              >
                {{ $t("inquiry.status") }}
              </span>
              <span
                v-else-if="props.column.label === 'ชื่อลูกค้า'"
                class="text-nowrap"
              >
                {{ $t("inquiry.customer_name") }}
              </span>
              <span
                v-else-if="props.column.label === 'ประเภทงาน'"
                class="text-nowrap"
              >
                {{ $t("inquiry.type") }}
              </span>
              <span
                v-else-if="props.column.label === 'ประเภทเอกสาร'"
                class="text-nowrap"
              >
                {{ $t("inquiry.doc_type") }}
              </span>
              <span
                v-else-if="props.column.label === 'สถานที่รับ'"
                class="text-nowrap"
              >
                {{ $t("inquiry.origin_port") }}
              </span>
              <span
                v-else-if="props.column.label === 'สถานที่จัดส่ง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.destination_port") }}
              </span>
              <span
                v-else-if="props.column.label === 'กำหนดจัดส่ง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.delivery_time") }}
              </span>
              <span
                v-else-if="props.column.label === 'ผู้สร้าง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.create_by") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่สร้าง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.create_date") }}
              </span>
              <span
                v-else-if="props.column.label === 'ผู้แก้ไข'"
                class="text-nowrap"
              >
                {{ $t("inquiry.update_by") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่แก้ไข'"
                class="text-nowrap"
              >
                {{ $t("inquiry.update_date") }}
              </span>
              <span v-else>
                {{ props.column.label }}
              </span>
            </template>
            <template slot="table-row" slot-scope="props">
              <!-- Column: Action -->
              <span v-if="props.column.field === 'action'">
                <div class="text-center">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-primary"
                    class="btn-icon rounded-circle mr-1"
                    v-b-tooltip.hover.v-primary
                    title="Edit"
                    @click="onEdit(props.index, props.row.intRequestId)"
                  >
                    <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-secondary"
                    class="btn-icon rounded-circle mr-1"
                    v-b-tooltip.hover.v-secondary
                    title="Duplicate"
                    @click="onDuplicate(props.index, props.row.intRequestId)"
                  >
                    <font-awesome-icon icon="fa-solid fa-copy" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-info"
                    class="btn-icon rounded-circle mr-1"
                    v-b-tooltip.hover.v-info
                    title="Print"
                    @click="btnPrintPdf(props.index, props.row.intRequestId)"
                    :disabled="
                      props.row.strStatus == 'Draft' ||
                      props.row.strStatus == 'ร่าง'
                    "
                  >
                    <font-awesome-icon icon="fa-solid fa-print" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="btn-icon rounded-circle"
                    v-b-tooltip.hover.v-danger
                    title="Delete"
                    @click="onDelete(props.index, props.row.intRequestId)"
                    :disabled="
                      props.row.strStatus != 'Draft' &&
                      props.row.strStatus != 'ร่าง'
                    "
                  >
                    <font-awesome-icon icon="fa-solid fa-trash" />
                  </b-button>
                </div>
                <div class="text-center">
                  <br />
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-warning"
                    class="btn-icon rounded"
                    v-b-tooltip.hover.v-warning
                    title="Info"
                    @click="onInfo(props.index, props.row.intRequestId)"
                    :disabled="
                      props.row.strStatus == 'Draft' ||
                      props.row.strStatus == 'Submit' ||
                      props.row.strStatus == 'Return' ||
                      props.row.strStatus == 'ร่าง' ||
                      props.row.strStatus == 'รอดำเนินการ' ||
                      props.row.strStatus == 'ขอคืนงาน'
                    "
                  >
                    <font-awesome-icon icon="fa-solid fa-info-circle" />
                    {{ $t("inquiry.doc_detail") }}
                  </b-button>
                </div>
              </span>
              <!-- Column: Status -->
              <span v-else-if="props.column.field === 'strStatus'">
                <div class="text-center">
                  <b-badge :variant="statusVariant2(props.row.strStatus)">
                    {{ props.row.strStatus }}
                  </b-badge>
                </div>
              </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Showing 1 to </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['5', '10', '25']"
                    class="mx-1"
                    @input="
                      (pageLength) =>
                        props.perPageChanged({
                          currentPerPage: pageLength,
                        })
                    "
                  />
                  <span class="text-nowrap">
                    of {{ props.total }} entries
                  </span>
                </div>
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="
                      (pageLength) =>
                        props.pageChanged({
                          currentPage: pageLength,
                        })
                    "
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      ref="info-view"
      size="lg"
      hide-footer
      :title="locals('msg.detail')"
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row class="pt-1">
        <b-col sm="4">
          <b-form-group
            label-for="i-jobno"
            label="Job No."
            class="title-freight"
          >
            <b-form-input id="i-jobno" v-model="form.strRQMJobNo" disabled />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-date"
            :label="locals('msg.date')"
            class="title-freight"
          >
            <b-form-input
              id="i-date"
              v-model="form.datLastDeliveredDateDMY"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-rider"
            :label="locals('msg.rider_name')"
            class="title-freight"
          >
            <b-form-input id="i-rider" v-model="form.strShowName" disabled />
          </b-form-group>
        </b-col>
        <b-col sm="12" class="text-left">
          <label for="i-note" class="title-freight">
            {{ $t("inquiry.remark") }}
          </label>
          <b-form-textarea
            id="i-note"
            rows="2"
            v-model="form.strActionNote"
            disabled
          />
        </b-col>
        <b-col sm="12" class="text-left pt-1">
          <label for="i-recvlocation" class="title-freight">
            {{ $t("inquiry.pick_up_address") }}
          </label>
          <b-form-textarea
            id="i-recvlocation"
            rows="2"
            v-model="form.strRecvLocation"
            disabled
          />
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-recv-District"
            :label="locals('inquiry.district')"
            class="title-freight pt-1"
          >
            <b-form-input
              id="i-recv-District"
              v-model="form.strRecvDistrict"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-recv-SubDistrict"
            :label="locals('inquiry.sub_district')"
            class="title-freight pt-1"
          >
            <b-form-input
              id="i-recv-SubDistrict"
              v-model="form.strRecvSubDistrict"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-recv-province"
            :label="locals('inquiry.city')"
            class="title-freight pt-1"
          >
            <b-form-input
              id="i-recv-province"
              v-model="form.strRecvProvince"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-recv-postcode"
            :label="locals('inquiry.post_code')"
            class="title-freight"
          >
            <b-form-input
              id="i-recv-postcode"
              v-model="form.strRecvPostCode"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" class="text-left pt-1">
          <label for="i-destlocation" class="title-freight">
            {{ $t("inquiry.delivery_address") }} - ({{ $t("inquiry.lastest") }})
          </label>
          <b-form-textarea
            id="i-destlocation"
            rows="2"
            v-model="form.strDestLocation"
            disabled
          />
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-District"
            :label="locals('inquiry.district')"
            class="title-freight pt-1"
          >
            <b-form-input
              id="i-District"
              v-model="form.strDestDistrict"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-SubDistrict"
            :label="locals('inquiry.sub_district')"
            class="title-freight pt-1"
          >
            <b-form-input
              id="i-SubDistrict"
              v-model="form.strDestSubDistrict"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-province"
            :label="locals('inquiry.city')"
            class="title-freight pt-1"
          >
            <b-form-input
              id="i-province"
              v-model="form.strDestProvince"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label-for="i-postcode"
            :label="locals('inquiry.post_code')"
            class="title-freight"
          >
            <b-form-input
              id="i-postcode"
              v-model="form.strDestPostCode"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <div class="vertical-center m-map">
            <p class="title-freight">{{ $t("inquiry.act_location") }}</p>
            <iframe
              id="my-iframe"
              v-if="iframeSrc"
              :src="iframeSrc"
              width="700"
              height="200"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
            ></iframe>
          </div>
        </b-col>
        <b-col md="12">
          <p class="title-freight pt-1">{{ $t("inquiry.proof_delivery") }}</p>
          <span v-for="obj3 in listFile">
            <a href="#" @click="onView(obj3)">
              <feather-icon
                icon="DownloadIcon"
                class="mr-50"
                stroke="blue"
                fill="blue"
              />
              {{ obj3.strFileName }}
            </a>
          </span>
        </b-col>
      </b-row>
      <b-row>
        <hr />
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="hideModal"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import XLSX from "xlsx";
import VueGeolocation from "vue-browser-geolocation";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BPagination,
  BBadge,
  BFormSelect,
  BFormRadio,
  BFormTextarea,
  VBModal,
  VBTooltip,
  BSpinner,
  BOverlay,
  BFormCheckbox,
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

import Service from "@/@API/cDropdown";
import ReqService from "@/@API/cRequest";

export default {
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCard,
    BInputGroup,
    vSelect,
    BInputGroupAppend,
    BButton,
    flatPickr,
    VueGoodTable,
    BPagination,
    BBadge,
    BFormSelect,
    BFormRadio,
    BFormTextarea,
    BSpinner,
    BOverlay,
    BFormCheckbox,
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    statusVariant2() {
      const statusColor2 = {
        Draft: "light-info",
        Submit: "light-info",
        Accept: "light-primary",
        Delivered: "light-success",
        "Delivery-Failed": "light-danger",
        Completed: "light-success",
        "In-Completed": "light-primary",
        Return: "light-warning",
      };
      return (table_status2) => statusColor2[table_status2];
    },
  },
  data() {
    return {
      searchQuery: "",
      vlocation: {},
      iframeSrc: "",
      iframeSrct: "",
      APIKEY: "AIzaSyAcGdDqkeJcCqh4VW1d8zrLuAJrLmJE7oY",
      busy: true,
      processing: false,
      isLoading: true,
      dataFilter: {
        intCustomerId: "",
        strCustomerName: "",
        strInqJobNo: "",
        intStatusId: "",
        strStatus: "",
        datDate: "",
        datStartDate: "",
        datEndDate: "",
        strOriginalPort: "",
        strDestPort: "",
        strRemark: "",
        strJobType: "",
        select_flag: true,
        strSelect: "all",
      },
      form: {},
      custOption: [{ strDsName: "Loading...", intDsId: 1 }],
      doctypeOption: [],
      TestOptions: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      job_type: [
        { title: "รับเอกสาร", Id: 1 },
        { title: "ส่งเอกสาร", Id: 2 },
      ],
      ori_status: [
        { title: "Draft", Id: 3, lang: "en_US" },
        { title: "Submit", Id: 4, lang: "en_US" },
        { title: "Accept", Id: 5, lang: "en_US" },
        { title: "Delivered", Id: 6, lang: "en_US" },
        { title: "Delivery-Failed", Id: 7, lang: "en_US" },
        { title: "Completed", Id: 8, lang: "en_US" },
        { title: "In-Completed", Id: 9, lang: "en_US" },
        { title: "Return", Id: 10, lang: "en_US" },
        { title: "ร่าง", Id: 3, lang: "th_TH" },
        { title: "รอดำเนินการ", Id: 4, lang: "th_TH" },
        { title: "รับงาน", Id: 5, lang: "th_TH" },
        { title: "นำส่งเอกสาร", Id: 6, lang: "th_TH" },
        { title: "ส่งเอกสารไม่สำเร็จ", Id: 7, lang: "th_TH" },
        { title: "เสร็จสิ้น", Id: 8, lang: "th_TH" },
        { title: "ดำเนินการไม่สำเร็จ", Id: 9, lang: "th_TH" },
        { title: "ขอคืนงาน", Id: 10, lang: "th_TH" },
      ],
      status: [],
      table_status2: [
        {
          0: "Draft",
          1: "Submit",
          2: "Accept",
          3: "Delivery-Failed",
          4: "In-Completed",
          5: "Return",
          6: "Completed",
          7: "Delivered",
        },
        {
          0: "light-info",
          1: "light-info",
          2: "light-primary",
          3: "light-danger",
          4: "light-primary",
          5: "light-warning",
          6: "light-success",
          7: "light-success",
        },
      ],
      pageLength: 5,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "Action",
          field: "action",
          width: "220px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อลูกค้า",
          field: "strCustomerName",
          width: "250px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Request Job no.",
          field: "strRQMJobNo",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "กำหนดจัดส่ง",
          field: "datOrderDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานะ",
          field: "strStatus",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ประเภทงาน",
          field: "strJobType",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ประเภทเอกสาร",
          field: "strDocType",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานที่รับ",
          field: "strRecvLocation",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานที่จัดส่ง",
          field: "strDestLocation",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้สร้าง",
          field: "strCreatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่สร้าง",
          field: "datCreatedDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้แก้ไข",
          field: "strUpdatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่แก้ไข",
          field: "datUpdatedDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      rows: [],
      listFile: [
        {
          intDetailId: 4,
          strFileName: "Deli_33_18_1_Image2.png",
        },
      ],
    };
  },
  mounted() {
    localStorage.setItem("request-id", -1);
    localStorage.setItem("request-status", "New");
    this.getDefault();
    this.onClear();
  },
  watch: {
    iframeSrc(newSrc) {
      const iframe = document.getElementById("my-iframe");
      iframe.src = newSrc;
    },
  },
  methods: {
    getDefault() {
      let lang = localStorage.getItem("language");
      let newstatus = [];
      newstatus = this.ori_status.filter((b) => b.lang == lang);
      this.status = newstatus;

      Service.getCustomerDropdown({})
        .then((response) => {
          this.custOption = [];
          response.data.lstCustomer.forEach((cc) => {
            this.custOption.push(cc);
          });

          this.doctypeOption = [];
          response.data.lstReqForm.forEach((e) => {
            this.doctypeOption.push(e);
          });

          console.log("response", response);
          //this.busy = false;
          //this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onExport() {
      var list = [];
      this.rows.forEach(function (v, k) {
        list.push({
          ชื่อลูกค้า: v.strCustomerName,
          "Request Job No.": v.strRQMJobNo,
          กำหนดส่ง: v.datOrderDateDMY,
          สถานะ: v.strStatus,
          ประเภทงาน: v.strJobType,
          ประเภทเอกสาร: v.strDocType,
          สถานที่รับเอกสาร: v.strRecvLocation,
          สถานที่จัดส่ง: v.strDestLocation,
          ผู้สร้าง: v.strCreatedBy,
          วันที่สร้าง: v.datCreatedDateDMY,
          ผู้แก้ไขล่าสุด: v.strUpdatedBy,
          วันที่แก้ไขล่าสุด: v.datUpdatedDateDMY,
        });
      });
      const dataWS = XLSX.utils.json_to_sheet(list);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export_msgrequest.xlsx");
    },
    btnPrintPdf(index, Id) {
      window.open(
        process.env.VUE_APP_API_BASE_URL +
          "api/v1/pdf/getFormRequestPdf?intRequestId=" +
          Id +
          "&strMode=" +
          "-",
        "_blank"
      );
    },
    onSearch() {
      if (
        this.dataFilter.intCustomerId != "" &&
        this.dataFilter.intCustomerId != null
      ) {
        let currCust = this.custOption.find(
          (c) => c.intDsId === this.dataFilter.intCustomerId
        );
        this.dataFilter.strCustomerName = currCust.strDsName;
      }
      if (
        this.dataFilter.intStatusId != "" &&
        this.dataFilter.intStatusId != null
      ) {
        let sta = this.ori_status.find(
          (c) => c.Id === this.dataFilter.intStatusId
        );
        this.dataFilter.strStatus = sta.title;
      }

      if (this.dataFilter.datDate != "") {
        let result = this.dataFilter.datDate.substring(0, 10);
        let result2 = this.dataFilter.datDate.substring(13, 24);
        // const myStartDate = moment(result, "YYYY-MM-DD").toDate();
        const myStartDate = moment(result, "DD/MM/YYYY").format("YYYY-MM-DD");
        const myEndDate = moment(result2, "DD/MM/YYYY").format("YYYY-MM-DD");
        this.dataFilter.datStartDate = myStartDate;
        this.dataFilter.datEndDate = myEndDate;
        //console.log(myStartDate);
        //console.log(myEndDate);
      } else {
        this.dataFilter.datStartDate = "";
        this.dataFilter.datEndDate = "";
      }

      if (this.dataFilter.select_flag) {
        this.dataFilter.strSelect = "only";
      } else {
        this.dataFilter.strSelect = "all";
      }

      this.busy = true;
      this.isLoading = true;

      ReqService.getSearchRequest(this.dataFilter)
        .then((response) => {
          console.log(response.data);
          this.busy = false;
          this.isLoading = false;
          let lang = localStorage.getItem("language");
          this.rows = response.data;
          this.rows.forEach((q) => {
            q.datOrderDateDMY = q.datOrderDate
              ? moment(q.datOrderDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datCreatedDateDMY = q.datCreatedDate
              ? moment(q.datCreatedDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datUpdatedDateDMY = q.datUpdatedDate
              ? moment(q.datUpdatedDate).format("DD/MM/YYYY HH:mm")
              : null;

            if (q.strLastDeliveredName != "" && q.strLastDeliveredName != "-") {
              q.strShowName = q.strLastDeliveredName;
            } else {
              q.strShowName = q.strLastAcceptName;
            }

            if ((q.intJobTypeId = 1)) {
              q.strJobType = "รับเอกสาร";
            }
            if ((q.intJobTypeId = 2)) {
              q.strJobType = "ส่งเอกสาร";
            }

            let currdoc = this.doctypeOption.find(
              (ddd) => ddd.intDsId === q.intDocTypeId && ddd.strLanguage == lang
            );
            if (currdoc) {
              q.strDocType = currdoc.strDsName;
            }

            let recvtext = "";
            recvtext =
              q.strRecvLocationName +
              " " +
              q.strRecvAddrName +
              " " +
              q.strRecvSubDistrict +
              " " +
              q.strRecvDistrict +
              " " +
              q.strRecvProvince +
              " " +
              q.strRecvPostCode;
            if (q.strRecvLocationNote != "" && q.strRecvLocationNote != null) {
              recvtext = recvtext + " " + q.strRecvLocationNote;
            }
            recvtext = recvtext + " " + q.strRecvContactName;
            recvtext = recvtext + " " + q.strRecvContactTelNo;
            q.strRecvLocation = recvtext;

            let desttext = "";
            desttext =
              q.strDestLocationName +
              " " +
              q.strDestAddrName +
              " " +
              q.strDestSubDistrict +
              " " +
              q.strDestDistrict +
              " " +
              q.strDestProvince +
              " " +
              q.strDestPostCode;
            if (q.strDestLocationNote != "" && q.strDestLocationNote != null) {
              desttext = desttext + " " + q.strDestLocationNote;
            }
            desttext = desttext + " " + q.strDestContactName;
            desttext = desttext + " " + q.strDestContactTelNo;
            q.strDestLocation = desttext;
          });
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          console.log("error", error);
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onInfo(index, Id) {
      this.form = {};

      let currReq = this.rows.find((c) => c.intRequestId === Id);
      this.form = currReq;

      this.form.datLastDeliveredDateDMY = this.form.datLastDeliveredDate
        ? moment(this.form.datLastDeliveredDate).format("DD/MM/YYYY HH:mm")
        : null;
      if (this.form.strLocationLat != null) {
        // this.iframeSrc =
        //   "http://maps.google.com/maps?q=" +
        //   this.form.strLocationLat +
        //   "," +
        //   this.form.strLocationLng +
        //   "&z=16&output=embed";

        this.iframeSrc =
          "https://www.google.com/maps/embed/v1/place?key=" +
          this.APIKEY +
          "&q=" +
          this.form.strLocationLat +
          "," +
          this.form.strLocationLng +
          "&zoom=16";
      }

      this.listFile = [];
      ReqService.getRequestDeliveredFile({
        intRequestId: this.form.intRequestId,
      })
        .then((response) => {
          const maxAddrId = Math.max(
            ...response.data.listFile.map((file) => file.intAddrId)
          );
          const existfile = response.data.listFile.filter(
            (file) => file.intAddrId === maxAddrId
          );
          existfile.forEach((ff) => {
            let obj = {
              intDetailId: ff.intDetailId,
              strFileName: ff.strFileName,
            };
            this.listFile.push(obj);
          });
        })
        .catch((error) => {});

      this.$refs["info-view"].show();
    },
    hideModal() {
      this.$refs["info-view"].hide();
    },
    onView(url) {
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:9090";
      window.open(`${baseUrl}api/v1/fpview/Deli/${url.strFileName}`, "_blank");
    },
    onEdit(index, Id) {
      this.$router.replace({ name: "request-form" }).then(() => {
        localStorage.setItem("request-id", Id);
        localStorage.setItem("request-status", "Edit");
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "แก้ไขเอกสาร",
              icon: "EditIcon",
              variant: "warning",
              text: "กำลังแก้ไขเอกสาร",
            },
          },
          {
            position: "top-center",
          }
        );
      });
    },
    onDuplicate(index, Id) {
      this.$router.replace({ name: "request-form" }).then(() => {
        localStorage.setItem("request-id", Id);
        localStorage.setItem("request-status", "Duplicate");
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "คัดลองเอกสาร",
              icon: "CopyIcon",
              variant: "success",
              text: "กำลังคัดลองเอกสาร",
            },
          },
          {
            position: "top-center",
          }
        );
      });
    },
    onDelete(index, Id) {
      let lang = localStorage.getItem("language");

      let tttitle = "Confirm Delete";
      let msg = "Do you want to delete this request?";
      let b1 = "Delete";
      let b2 = "Close";

      if (lang == "th_TH") {
        tttitle = "ยืนยันการลบ";
        msg = "คุณต้องการยืนยันลบเอกสารนี้ใช่หรือไม่ ?";
        b1 = "ลบ";
        b2 = "ปิด";
      }

      this.$bvModal
        .msgBoxConfirm(msg, {
          title: tttitle,
          size: "sm",
          modalClass: "modal-danger",
          okVariant: "danger",
          okTitle: b1,
          cancelTitle: b2,
          cancelVariant: "outline-warning",
          hideHeaderClose: false,
          //centered: true,
        })
        .then((value) => {
          this.busy = true;
          this.processing = true;
          console.log(value);
          if (value) {
            ReqService.getResponseDeleteRequest({ intRequestId: Id })
              .then((response) => {
                this.busy = false;
                this.processing = false;
                if (
                  response.data == "ไม่พบรายชื่อ" ||
                  response.data == "ไม่พบเอกสาร" ||
                  response.data == "ไม่สามารถลบได้"
                ) {
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "Something was wrong",
                        icon: "FrownIcon",
                        variant: "danger",
                        text: response.data,
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                } else {
                  this.rows.splice(index, 1);
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "ลบข้อมูล",
                        icon: "XIcon",
                        variant: "success",
                        text: "ลบสำเร็จ",
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                }
              })
              .catch((error) => {
                this.busy = false;
                this.processing = false;
                console.log("error", error);
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "Something was wrong",
                      icon: "FrownIcon",
                      variant: "danger",
                      text: "Something was wrong : " + error,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
              });
          }
        });
    },
    onClear() {
      this.busy = true;
      this.isLoading = true;

      this.dataFilter = {
        intCustomerId: "",
        strCustomerName: "",
        strInqJobNo: "",
        intStatusId: "",
        strStatus: "",
        datDate: "",
        datStartDate: "",
        datEndDate: "",
        strOriginalPort: "",
        strDestPort: "",
        strRemark: "",
        strJobType: "",
        select_flag: true,
        strSelect: "all",
      };

      let today = moment().format("DD/MM/YYYY");
      let tomorrow = moment().add(1, "days").format("DD/MM/YYYY");
      this.dataFilter.datDate = [today, tomorrow];

      setTimeout(() => {
        this.onSearch();
      }, 2000);
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
